(ns serv-ui.mui
  "The Material components the window is drawn with, one module at a time,
  so a release ships only what is used."
  (:refer-clojure :exclude [Box List])
  (:require ["@mui/material/styles" :as mui-styles]
            ["@mui/material/useMediaQuery$default" :as mui-use-media-query]
            ["@mui/material/CssBaseline$default" :as mui-css-baseline]
            ["@mui/material/Alert$default" :as mui-alert]
            ["@mui/material/AlertTitle$default" :as mui-alert-title]
            ["@mui/material/Box$default" :as mui-box]
            ["@mui/material/Button$default" :as mui-button]
            ["@mui/material/Chip$default" :as mui-chip]
            ["@mui/material/Snackbar$default" :as mui-snackbar]
            ["@mui/material/CircularProgress$default" :as mui-circular-progress]
            ["@mui/material/Dialog$default" :as mui-dialog]
            ["@mui/material/DialogActions$default" :as mui-dialog-actions]
            ["@mui/material/DialogContent$default" :as mui-dialog-content]
            ["@mui/material/DialogTitle$default" :as mui-dialog-title]
            ["@mui/material/Divider$default" :as mui-divider]
            ["@mui/material/Fab$default" :as mui-fab]
            ["@mui/material/IconButton$default" :as mui-icon-button]
            ["@mui/material/Link$default" :as mui-link]
            ["@mui/material/List$default" :as mui-list]
            ["@mui/material/ListItem$default" :as mui-list-item]
            ["@mui/material/ListItemButton$default" :as mui-list-item-button]
            ["@mui/material/ListItemText$default" :as mui-list-item-text]
            ["@mui/material/ListSubheader$default" :as mui-list-subheader]
            ["@mui/material/Menu$default" :as mui-menu]
            ["@mui/material/MenuItem$default" :as mui-menu-item]
            ["@mui/material/Paper$default" :as mui-paper]
            ["@mui/material/Table$default" :as mui-table]
            ["@mui/material/TableBody$default" :as mui-table-body]
            ["@mui/material/TableCell$default" :as mui-table-cell]
            ["@mui/material/TableHead$default" :as mui-table-head]
            ["@mui/material/TableRow$default" :as mui-table-row]
            ["@mui/material/TextField$default" :as mui-text-field]
            ["@mui/material/ToggleButton$default" :as mui-toggle-button]
            ["@mui/material/Typography$default" :as mui-typography]))

(def ThemeProvider mui-styles/ThemeProvider)
(def use-media-query mui-use-media-query)
(def CssBaseline mui-css-baseline)
(def Alert mui-alert)
(def AlertTitle mui-alert-title)
(def Dialog mui-dialog)
(def DialogActions mui-dialog-actions)
(def DialogContent mui-dialog-content)
(def DialogTitle mui-dialog-title)
(def Box mui-box)
(def Button mui-button)
(def Chip mui-chip)
(def CircularProgress mui-circular-progress)
(def Divider mui-divider)
(def Fab mui-fab)
(def IconButton mui-icon-button)
(def Link mui-link)
(def List mui-list)
(def ListItem mui-list-item)
(def ListItemButton mui-list-item-button)
(def ListItemText mui-list-item-text)
(def ListSubheader mui-list-subheader)
(def Menu mui-menu)
(def MenuItem mui-menu-item)
(def Paper mui-paper)
(def Snackbar mui-snackbar)
(def Table mui-table)
(def TableBody mui-table-body)
(def TableCell mui-table-cell)
(def TableHead mui-table-head)
(def TableRow mui-table-row)
(def TextField mui-text-field)
(def ToggleButton mui-toggle-button)
(def Typography mui-typography)

(defn sx
  "A style for MUI. It reads plain objects only; a map left unconverted
  would be a style that silently does nothing."
  [m]
  (clj->js m))
